import sourceCatalog from './generated/sourceCatalog.js';

const bases={website:'websites',software:'software',product:'products',media:'media',broadcast:'broadcast',research:'research',center:'centers',children:'children',competition:'competitions',exhibition:'exhibitions'};
const labels={website:'موقع إلكتروني',software:'برنامج حاسوبي',product:'منتج',media:'إصدار مرئي أو صوتي',broadcast:'قناة أو إذاعة',research:'بحث أو كتاب',center:'مركز تعليم',children:'مورد للأطفال',competition:'مسابقة أو جائزة',exhibition:'معرض أو متحف'};
const slugify=(title,index)=>`${String(title).normalize('NFKC').replace(/[^\p{L}\p{N}]+/gu,'-').replace(/^-|-$/g,'').slice(0,78)}-${index+1}`;
const imageOverrides={
  'https://www.guidetosunnah.com/storage/posts/41kyej2-gil-ac-sy400295.jpg':'/assets/images/products/car-door-adhkar-device-hq.png',
  'https://www.guidetosunnah.com/storage/posts/51j2nljykjl-ac460.jpg':'/assets/images/products/prophetic-biography-media-board-hq.png',
  'https://www.guidetosunnah.com/storage/posts/51vz-whvuyl-ac461.jpg':'/assets/images/products/best-toy-prophetic-biography-hq.png',
  'https://www.guidetosunnah.com/storage/posts/alklm584.png':'/assets/images/products/islamic-audiobooks-children-hq.png',
  'https://www.guidetosunnah.com/storage/posts/syar585.png':'/assets/images/products/car-islamic-adhkar-device-hq.png',
  'https://www.guidetosunnah.com/storage/posts/taalym586.png':'/assets/images/products/prophetic-biography-learning-device-hq.png',
  'https://www.guidetosunnah.com/storage/posts/screenshot-2023-02-09-212117717.jpg':'/assets/images/competitions/naif-international-prize-hq.png',
  'https://www.guidetosunnah.com/storage/posts/l-deayzi-400x400-1718.jpg':'/assets/images/competitions/prince-sultan-competition-hq.png',
  'https://www.guidetosunnah.com/storage/posts/screenshot-2023-02-09-212611720.jpg':'/assets/images/competitions/bahrain-education-award-hq.png',
  'https://www.guidetosunnah.com/storage/posts/screenshot-2023-03-07-172018743.png':'/assets/images/competitions/egypt-awqaf-competition-hq.png',
  'https://www.guidetosunnah.com/storage/posts/logo-1746.png':'/assets/images/competitions/jordan-hadith-competition-hq.png'
};
export const highQualityImage=source=>{
  const sourceUrl=String(source||'');
  const overrideKey=sourceUrl.replace(/_(?:relatedServiceThumb|showWebsiteThumb)(?=\.[a-z0-9]+(?:[?#].*)?$)/i,'');
  return imageOverrides[overrideKey]||sourceUrl;
};

export const catalogGroups=Object.fromEntries(Object.entries(sourceCatalog).filter(([type,group])=>type!=='app'&&group?.items).map(([type,group])=>{
  const items=group.items.map((item,index)=>{
    const image=highQualityImage(item.detailImage||item.image);
    return {
      ...item,image,detailImage:image,thumbnailImage:image,
      id:`${type}-${index+1}`,type,typeLabel:labels[type],slug:slugify(item.title,index),
      path:`/${bases[type]}/${slugify(item.title,index)}`,legacyPath:new URL(item.sourceUrl).pathname,
      shortDescription:item.description||'',description:item.description||'',images:[image].filter(Boolean),
      category:item.category?{label:item.category}:null,
      location:type==='center'?{country:item.country||'',city:'',address:''}:item.country||'',
      tags:[labels[type],item.category,item.country].filter(Boolean)
    };
  });
  return [type,{...group,items}];
}));

export const catalogResources=Object.values(catalogGroups).flatMap(group=>group.items);
export const getCatalogGroup=type=>catalogGroups[type]||{items:[],categories:[],pages:0};
